/**
 * Utility functions for date operations
 */

/**
 * Get today's date with time set to 00:00:00
 * @returns Date object representing today at midnight
 */
export function getToday(): Date {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
}

/**
 * Get today's date as a Date object (with current time)
 * @returns Date object representing today
 */
export function getCurrentDate(): Date {
  return new Date();
}
